import React from 'react'
import {
  Button,
  Grid,
  Modal,
  Stack,
  Typography,
  useMediaQuery,
  IconButton
} from '@mui/material'
import warningIcon from '../../../assets/images/warning.png'
import { theme } from '../../../theme/DashboardTheme'
import { selectActiveGrant } from '@meprism/shared/src/redux/product/ProductSlice'
import { useAppSelector } from '../../../redux/storeExports'
import { formatDate } from '../../../utils/helpers'
import closeicon from '../../../assets/images/successclose.png'
import { SubscriptionType } from '@meprism/shared/src/redux/product/ProductTypes'

interface AuthLetterRequiredModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  onDowngrade: (sub: SubscriptionType) => Promise<void>
  subscription: SubscriptionType
}

const DowngradeModal = (props: AuthLetterRequiredModalProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const grant = useAppSelector(selectActiveGrant)
  return (
    <Modal
      open={props.open}
      sx={{
        backdropFilter: 'blur(5px)',
        background: 'rgba(0, 0, 0, 0.01)',
      }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '600px',
          transform: 'translate(-50%, -50%)',
          width: !isMobile ? '30%' : '80%',
          background: '#fff',
          p: {xs: 5, sm: 6, md: 8},
          borderRadius: '10px',
        }}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => props.setOpen(false)}
            sx={{
              position: 'absolute',
              top: -60,
              right: 10,
              zIndex: 1,
              color: '#ffffff',
            }}
          >
            <img src={closeicon} style={{ width: '42px' }} />
          </IconButton>

        <Stack justifyContent="center" alignItems="center" flexDirection={'column'}>
          <img src={warningIcon} style={{  width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto', }} />
          <Typography 
            variant="h2"
            mt={{xs: 5, sm: 5, md: 6, lg: 7}} 
            textAlign="center"
            sx={{
              fontSize: {xs: 18, md: 21, lg: 23},
              fontWeight: 600,
              lineHeight: {xs: 1, md: 1.2, lg: 1.5},
            }}>
            You&apos;re downgrading your subscription!
          </Typography>
          <Typography 
            variant="body2" 
            textAlign="center" 
            color={'#615F6B'}
            my={{xs: 3, sm: 3, md: 4, lg: 5}} 
            sx={{
              fontSize: {xs: 12, md: 14, lg: 16},
              lineHeight: {xs: 1.2, md: 1.2, lg: 1.5},
              letterSpacing : '0'
            }}>
            The downgrade will take effect at the start of your next billing cycle {grant && `on ${formatDate(grant.grant_expiration)}.`}  
          </Typography>
        </Stack>
        <Grid item xs={12} sm={12} justifyContent="center" display="flex">
          <Button
            variant={'contained'}
            color={'darkPurple'}
            onClick={()=>{props.onDowngrade(props.subscription)}}
            sx={{
              width: {xs: '90%', sm: '100%', lg: '63%'},
              borderRadius: '10px',
              fontSize: {xs: 8, md: 13, lg: 14},
              boxShadow: 'unset',
              border: '2px solid #C67EFF',
              background: 'transparent',
              color: '#C67EFF',
              '&.Mui-disabled': {
                background: 'transparent',
                color: '#C67EFF',
              },
              ':hover': {
                background: 'transparent',
                color: '#C67EFF',
              },
            }}>
            Confirm Downgrade
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default DowngradeModal 